import { render, staticRenderFns } from "./EditJournalContent.vue?vue&type=template&id=2bb67a41"
import script from "./EditJournalContent.vue?vue&type=script&lang=js"
export * from "./EditJournalContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports